import React, {FunctionComponent} from "react"
import {useModal} from "@murphy-frontend/web-core/contexts/ModalContext"
import {ModalConfiguration} from "@murphy-frontend/web-core/components/Modal"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

interface ModifyOptionssRowProps {
	showDropDown: boolean
	onEdit: () => void
	onDelete: () => void
}

const ModifyOptionsRow: FunctionComponent<ModifyOptionssRowProps> = ({showDropDown, onEdit, onDelete}) => {
	const {openModal} = useModal()

	const {translations} = useUserPreferences()

	const handleDelete = () => {
		const modalConf: ModalConfiguration = {
			title: translations.delete || 'Delete',
			body: <div>	{translations.areYouSure || 'Are you sure you want to delete?'}</div>,
			buttonText: translations.yes || 'Yes',
			type: "warning",
			okCallback: () => {
				console.log("here")
				onDelete()
			}
		}

		openModal(modalConf)
	}

	return (
		<>
			{showDropDown && (
				<div className='actions-modify'>
					<div className='actions-modify-row' onClick={onEdit}>
						{translations.edit || 'Edit'}
					</div>
					<div className='actions-modify-row' onClick={handleDelete}>
					{translations.delete || 'Delete'}
					</div>
				</div>
			)}
		</>
	)
}

export default ModifyOptionsRow
